import { createAction } from 'redux-starter-kit';

export const SET_FIRM_CONFIG = 'meta/firm/config';
export const SET_DISCLAIMER = 'meta/firm/disclaimer';

export const setFirmConfig = createAction(SET_FIRM_CONFIG);
export const setDisclaimer = createAction(SET_DISCLAIMER);

export const firmActions = {
  setFirmConfig,
  setDisclaimer
};
